export const MARKET = {
  mwp: { name: "Zora", url: "https://zora.co/@mwp_token" },
  c1: { name: "OpenSea", url: "https://opensea.io/collection/metalandwolfpackexclusivecollection" },
  c2: { name: "OpenSea", url: "https://opensea.io/collection/metaland-wolfpack-2" },
  c3: { name: "OpenSea", url: "https://opensea.io/collection/project-pups-1" },
  sol: { name: "Magic Eden", url: "https://magiceden.io/marketplace/wp11" },
};
